import React from 'react'
import { DashboardRouteImport } from './Imports'
const { RoutesMap, Dashboard, ModuleDashboard } = DashboardRouteImport

const DashboardRoute = () => {
    return [
        {
            path: RoutesMap.DASHBOARD.path,
            element: <Dashboard />
        },
        {
            path: RoutesMap.DASHBOARDSECOND.path,
            element: <Dashboard />
        },
        {
            path: RoutesMap.INVENTORY_DASHBOARD.path,
            // key forces a fresh mount per dashboard so state resets without a duplicate fetch
            element: <ModuleDashboard key="inventory" />
        },
        {
            path: RoutesMap.ASSET_DASHBOARD.path,
            // key forces a fresh mount per dashboard so state resets without a duplicate fetch
            element: <ModuleDashboard key="asset" />
        },
        {
            path: RoutesMap.MAINTENANCE_DASHBOARD.path,
            // key forces a fresh mount per dashboard so state resets without a duplicate fetch
            element: <ModuleDashboard key="maintenance" />
        },
        {
            path: RoutesMap.AMC_DASHBOARD.path,
            // key forces a fresh mount per dashboard so state resets without a duplicate fetch
            element: <ModuleDashboard key="amc" />
        },
        {
            path: RoutesMap.PRODUCTION_DASHBOARD.path,
            // key forces a fresh mount per dashboard so state resets without a duplicate fetch
            element: <ModuleDashboard key="production" />
        },
    ]
}

export default DashboardRoute;